<template>
    <div v-show="display">
        <div class="tw-flex tw-items-center tw-justify-between alert alert-dismissable tw-p-4" :class="type">
            <div class="tw-whitespace-pre-line">
                <slot></slot>
            </div>
            <i class="fa fa-times tw-text-lg tw-cursor-pointer" data-dismiss="alert"></i>
        </div>
    </div>
</template>

<script>
export default {
    name: "FlashMessage",

    props: {
        type: {
            type: String,
            default: 'alert-success'
        },
        display: {
            type: Boolean,
            default: true
        }
    },

    mounted() {
        window.addEventListener('load', () => {
            window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
        });
    }
}
</script>